const getAssignedFeatures = [
  { id: 2, name: "Peer Challenge" },
  { id: 3, name: "Daily Challenge" },
  { id: 4, name: "Self Practice" },
  { id: 5, name: "Report" },
];
export default getAssignedFeatures;
